// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"441c8f63","314":"83133d45","681":"1089b783","739":"ce951c97","981":"e7a3d0a2"}[chunkId] + ".chunk.js";
};